/* eslint-disable max-len */
import React from 'react';

const TextHighlightIcon = props => (
  <svg width="19px" height="19px" viewBox="0 0 19 19" {...props}>
    <title>Fill Color</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M13,15.4025547 C13,16.1865787 13.687,16.8487889 14.5,16.8487889 C15.313,16.8487889 16,16.1863062 16,15.4025547 C16,14.7033546 15.6214705,13.9544845 14.8644116,13.1559444 L14.8643729,13.1559811 C14.6744053,12.9556048 14.3579691,12.9471668 14.1575928,13.1371343 C14.1513476,13.1430551 14.1452562,13.1491362 14.1393249,13.1553715 C13.379775,13.9538457 13,14.7029067 13,15.4025547 Z"
        fill="currentColor"
        fillRule="nonzero"
      />
      <path
        d="M3.5,6 C3.22385763,6 3,5.77614237 3,5.5 C3,5.22385763 3.22385763,5 3.5,5 L12.748729,5 C13.3010137,5 13.748729,5.44771525 13.748729,6 L13.748729,13 C13.748729,13.5522847 13.3010137,14 12.748729,14 L5.74872899,14 C5.19644424,14 4.74872899,13.5522847 4.74872899,13 L4.74872899,6 L3.5,6 Z M12.748729,6.00005457 L5.74872899,6.00005457 L5.74872899,13.0000546 L12.748729,6.00005457 Z"
        fill="currentColor"
        fillRule="nonzero"
        transform="translate(8.374364, 9.500000) rotate(-315.000000) translate(-8.374364, -9.500000) "
      />
    </g>
  </svg>
);

export default TextHighlightIcon;
/* eslint-enable max-len */
